import { render, staticRenderFns } from "./Vendor.vue?vue&type=template&id=6f210c42&scoped=true"
import script from "./Vendor.vue?vue&type=script&lang=js"
export * from "./Vendor.vue?vue&type=script&lang=js"
import style0 from "./Vendor.vue?vue&type=style&index=0&id=6f210c42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f210c42",
  null
  
)

export default component.exports